import { Empty } from "antd";
import { motion } from "framer-motion";

//STYLE
import { ContainerPorAtividade } from "./style";

//APP
import { numeroMilhar, transition_default } from "../../../../../../../utils";
import { ItemProgressoPorAtividade, ProgressoPorAtividade } from "../meta";

//PROPS
interface Props {
    dados: ProgressoPorAtividade;
    /**Atividade selecionada no select. Vazio = nada selecionado */
    nome_atividade: string;
    /**Termo digitado na busca de talhão */
    search_talhao: string;
    /**Com uma propriedade já filtrada na tela, o nome dela é redundante em todas as barras */
    ocultar_propriedade?: boolean;
    onClickTalhao?: (item: ItemProgressoPorAtividade) => void;
}

/**Cores por faixa de progresso, seguindo o padrão das barras da visão geral */
function obterCorBarra(porcentagem: number): string {
    if (porcentagem >= 100) return '#52c41a';
    if (porcentagem >= 70) return '#7ebd61';
    if (porcentagem >= 40) return '#faad14';
    return '#f14f46';
}

export const ProgressoPorAtividadeChart: React.FC<Props> = ({ dados, nome_atividade, search_talhao, ocultar_propriedade, onClickTalhao }) => {

    //NADA SELECIONADO AINDA
    if (!nome_atividade) {
        return (
            <ContainerPorAtividade>
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Selecione uma atividade para ver o progresso por talhão"
                />
            </ContainerPorAtividade>
        )
    }

    const { talhoes, qtd_talhoes, area_planejada, progresso_geral } = dados;

    if ((talhoes ?? []).length === 0) {
        return (
            <ContainerPorAtividade>
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={search_talhao
                        ? <>'<b>{search_talhao}</b>' não encontrado</>
                        : <>'<b>{nome_atividade}</b>' não foi planejada em nenhum talhão</>
                    }
                />
            </ContainerPorAtividade>
        )
    }

    return (
        <ContainerPorAtividade>
            <div className="PorAtividade__list">
                {(talhoes ?? []).map((item) => {
                    const { key, nome, porcentagem, area_total } = item;
                    const progresso = Number(porcentagem ?? 0);
                    const nome_propriedade = ocultar_propriedade ? '' : item.nome_propriedade;

                    return (
                        <button
                            key={key}
                            className="PorAtividade__list__item"
                            type="button"
                            onClick={onClickTalhao ? () => onClickTalhao(item) : undefined}
                            disabled={!onClickTalhao}
                            title={`${nome_propriedade ? `${nome_propriedade} / ` : ''}${nome} - ${progresso.toFixed(2)}%`}
                        >
                            <div className="PorAtividade__list__item__head">
                                <span className="PorAtividade__list__item__head__name">
                                    {nome}
                                    {!!nome_propriedade && (
                                        <small className="PorAtividade__list__item__head__name__propriedade">
                                            {nome_propriedade}
                                        </small>
                                    )}
                                </span>
                                <span className="PorAtividade__list__item__head__area">
                                    {area_total > 0 ? `${numeroMilhar(area_total)} ha` : 'sem área'}
                                </span>
                            </div>

                            <div className="PorAtividade__list__item__bar">
                                <div className="PorAtividade__list__item__bar__track">
                                    <motion.div
                                        className="PorAtividade__list__item__bar__track__progress"
                                        initial={{ width: '0%' }}
                                        animate={{ width: `${Math.min(progresso, 100).toFixed(2)}%` }}
                                        transition={{ ...transition_default, delay: 0.2 }}
                                        style={{ background: obterCorBarra(progresso) }}
                                    />
                                </div>
                                <span className="PorAtividade__list__item__bar__percent">
                                    {Math.round(progresso)}%
                                </span>
                            </div>
                        </button>
                    )
                })}
            </div>

            <div className="PorAtividade__footer">
                <span className="PorAtividade__footer__resumo">
                    {qtd_talhoes} {qtd_talhoes === 1 ? 'talhão' : 'talhões'}
                </span>
                <span className="PorAtividade__footer__total">
                    Progresso da atividade{' '}
                    <b className="PorAtividade__footer__total__valor">{Math.round(progresso_geral)}%</b>
                </span>
            </div>
        </ContainerPorAtividade>
    )
};
